import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="section" style={{ minHeight: '52vh', display: 'flex', alignItems: 'center' }}>
      <div className="shell">
        <p className="eyebrow">404</p>
        <h1>That page isn't here.</h1>
        <p className="lede" style={{ marginTop: '1.2rem' }}>
          It may have moved when we rebuilt the site. The Cyber Brief archive and the services
          pages are all still where you'd expect.
        </p>
        <div className="hero-actions" style={{ marginTop: '2rem' }}>
          <Link to="/" className="btn btn-primary">Home</Link>
          <Link to="/blog" className="btn btn-ghost">Cyber Brief</Link>
        </div>
      </div>
    </section>
  );
}
